import { NeedDto, NeedsHistoryEntryDto } from '@act/shared/data-transfer-objects';
import { FlexContainer, HtmlDisplayer, ResourceCard } from '@act/storybook';
import {
  mapCboRecordToResourceCardProps,
  mapLegacyResourceToResourceCardProps,
} from 'react-components/forms/cboResourceForm/mapToResourceDetails.util';
import { usePlacesAutocompleteEnabled } from 'react-components/places/usePlacesAutocompleteEnabled.hook';
import { callsAppSelectors } from 'redux/slices/callsSlice.slice';
import { metaSliceSelectors } from 'redux/slices/metaSlice.hook';
import { userAppSelectors } from 'redux/slices/usersSlice.slice';
import {
  StyledHistoryEntry,
  StyledHistoryEntryDescription,
  StyledHistoryEntrySubheader,
  getHistoryEntryDateLine,
} from './HistoryDisplay';

interface ResourceDetailsHistoryProps {
  need: NeedDto;
  historyEntry: NeedsHistoryEntryDto;
}

export const CallHistoryEntry = ({
  need,
  historyEntry,
}: ResourceDetailsHistoryProps) => {
  const call = callsAppSelectors.useSelectCallById(historyEntry.callId);
  const needMetadata = metaSliceSelectors.useSelectNeedsMetadata();
  const creator = userAppSelectors.useSelectUserById(call?.originator?.userId);
  const creatorName = creator?.name;
  const placesAutocompleteEnabled = usePlacesAutocompleteEnabled();
  const note = call?.note?.trim();
  const cboRecord = call?.needResourceInteraction?.cboRecord;
  const needIconOptions = {
    needIssueId: need.issueId,
    issues: needMetadata?.data?.issues,
  };

  const noteContent = note ? (
    <StyledHistoryEntryDescription>
      <HtmlDisplayer innerHtml={note} />
    </StyledHistoryEntryDescription>
  ) : null;

  const expandedContent =
    placesAutocompleteEnabled && historyEntry.resource?.title ? (
      <FlexContainer
        direction="column"
        gap={1}
        width="100%"
        overflowAllVisible
      >
        <ResourceCard
          {...(cboRecord
            ? mapCboRecordToResourceCardProps(cboRecord, needIconOptions)
            : mapLegacyResourceToResourceCardProps(
                historyEntry.resource,
                needIconOptions
              ))}
        />
        {noteContent}
      </FlexContainer>
    ) : (
      noteContent
    );

  return (
    <StyledHistoryEntry
      header={`Resource Called: ${historyEntry.resource.title}`}
      content={
        <StyledHistoryEntrySubheader>
          {getHistoryEntryDateLine(historyEntry?.createdAt, creatorName)}
        </StyledHistoryEntrySubheader>
      }
      expandedContent={expandedContent}
    />
  );
};
